export default {
      id: "Icon--cart-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--cart",
      toString: function () {
        return this.url;
      }
    }